import React from "react";

export default function MyAccountCardsShimmer() {
  return (
    <div className="sprint16-myacc-cards1">
    {[1,2].map(item => (
    <div className="sprint16-myacc-cards3 pointer shimmer-effect bg-white">
      <div class="sprint16-myacc-card03">
        <div class="s16-card01-left w-100">
          <div class="img-div">
            <div
              class="shimmerBG m-0 shimmer-button-sm"
              style={{ height: "26px", width: "26px" }}
            ></div>
          </div>
          <div class="s16-card01-cont w-100">
            <h5 class=" shimmerBG m-0 shimmer-h25 w-25"></h5>
            <p
              class=" shimmerBG m-0 shimmer-h15 w-50 mt-1"
              style={{ fontSize: "18px", lineHeight: "18px" }}
            ></p>
          </div>
        </div>
        <div class="right-arrow-btn">
          <div class="shimmer-icon-xs shimmerBG"></div>
        </div>
      </div>
    </div>))}
    </div>
  );
}
